@if (operationContainer.currentOperation.$$showOperationView) {
  <div
    class="operation-view-object"
    [@slideObjectMenuCurrent]
  >
    <div
      class="operation-view-object__content"
      [hidden]="operationContainer.currentOperation.no_operation_view"
    >
      <div class="operation-view-object__top">
        <div class="operation-view-object__top-content">
          <i
            class="{{operationContainer.currentOperation.menu_icon}}"
          ></i>

          <h1 class="light operation-view-object__top-title">
            {{ operationContainer.currentOperation.menu_title | translate }}
          </h1>
        </div>
      </div>

      <div class="operation-view-object__view">
        @if (!operationContainer.currentOperation.upload_info) {
          <app-operation-view-section-container
            [operationContainer]="operationContainer"
            [operationStepIndex]="operationContainer.currentOperation.$$currentStepIndex"
          ></app-operation-view-section-container>
        }
        @else {
          <app-operation-view-upload
            [operationContainer]="operationContainer"
            [operationStepIndex]="operationContainer.currentOperation.$$currentStepIndex"
          ></app-operation-view-upload>
        }
      </div>
    </div>
  </div>
}
